<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">納入指示メール送信</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ul>
          <li>1） 所有S/A確定的在此显示，其他的不需要</li>

          <li>2） 【送信解除】时发送email告知纳入申请取消了，不在B0600页面显示，回退到B0500</li>

          <li>3） 送信，显示在B0600</li>

          <li>4） 可以不用分页</li>

          <li>5） CaseNo From就是Carton No</li>

          <li>6） 通关业者，可以通过弹出式选择【拥有通关服务的供应商】批量更新</li>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      username: null,
      password: null
    }
  }
}
</script>
<style scoped>
.login {
  position: absolute;
  top: 100px;
  right: 300px;
  width: 400px;
}
</style>
